import React from 'react';
import { formatNumberShort } from 'shared/utils/format-number-short';
import { isNumber } from 'shared/utils/is-number';

import * as Styled from './statistic-card.style';

export type StatisticCardProps = {
  value?: number;
  target?: number;
  description?: string;
  isPercentage?: boolean;
  isFormatted?: boolean;
};

export const StatisticCard: React.FC<StatisticCardProps> = ({
  value,
  target,
  description,
  isPercentage,
  isFormatted,
}) => (
  <Styled.Container>
    <Styled.Body>
      {!!description && <Styled.Description>{description}</Styled.Description>}
    </Styled.Body>

    <Styled.Header>
      <Styled.Data>
        <Styled.Value>
          {`${value ? (isFormatted ? formatNumberShort(value) : value) : '0'}${isPercentage && isNumber(value) ? '%' : ''}`}
        </Styled.Value>
        {isNumber(target) && (
          <Styled.Target>
            / {isFormatted ? formatNumberShort(target!) : target}
          </Styled.Target>
        )}
      </Styled.Data>
    </Styled.Header>
  </Styled.Container>
);
